import React from 'react'
import './iOSAudioEnabler.css'
import speak from './utils/speak'

class ModaliOSAudioEnabler extends React.PureComponent {
  constructor () {
    super()
    this.state = {
      playedAudio: false,
      hideEnabler: false,
      timer: null
    }
    this.playAudio = this.playAudio.bind(this)
    this.confirmSound = this.confirmSound.bind(this)
  }
  playAudio () {
    // window.MARIO_COIN.play()
    speak('audio enabled')
    this.setState({hideEnabler: true})
    clearTimeout(this.state.timer)
    this.setState({
      timer: setTimeout(() => {
        this.setState({playedAudio: true})
      }, 300)
    })
  }
  componentWillUnmount () {
    clearTimeout(this.state.timer)
  }
  confirmSound (confirmed) {
    if (confirmed === true) {
      this.setState({
        hideEnabler: true
      })
    } else {
      this.setState({
        playedAudio: false
      })
    }
  }
  render () {
    if (this.state.hideEnabler) {
      return null
    } else {
      return (
        <div className="modal-ios-audio-enabler" onClick={this.playAudio}>


          <div className="instructions">
            <p>
              Sound Check
            </p>
            <AlarmSVG/>

            {this.state.playedAudio ?
              <div>
                Did you hear the sound?
                <div className="yes-no">
                  <p>If not, check if you muted the device or turned down the volumn.</p>
                  <button onClick={this.confirmSound.bind(this, true)}>Yes, I heard it.</button>
                </div>
              </div>
              : <p>(click me)</p> }
          </div>

        </div>
      )
    }
    }
}


const AlarmSVG = () => {
  return(
    <div className="alarm">
      <svg xmlns="http://www.w3.org/2000/svg" version="1.1" x="0px" y="0px" viewBox="0 0 100 100" enableBackground="new 0 0 100 100"><g><g><path d="M64.968,21.295l-1.139,2.778c-0.206,0.502,0.032,1.065,0.525,1.292c7.583,3.499,12.641,10.996,13.046,19.337    c0.026,0.542,0.459,0.974,1.002,0.971l3.002-0.017c0.562-0.003,1.024-0.47,1.001-1.031c-0.438-10.317-6.704-19.603-16.106-23.872    C65.787,20.521,65.181,20.775,64.968,21.295z"></path><path d="M68.765,12.04l-1.138,2.775c-0.206,0.503,0.033,1.07,0.53,1.291c11.298,5.033,18.816,16.176,19.253,28.537    c0.019,0.544,0.455,0.977,0.999,0.974l2.999-0.017c0.561-0.003,1.02-0.468,1.002-1.028c-0.465-14.341-9.193-27.277-22.316-33.078    C69.58,11.269,68.977,11.521,68.765,12.04z"></path></g><g><path d="M35.032,21.295l1.139,2.778c0.206,0.502-0.032,1.065-0.525,1.292C28.064,28.864,23.005,36.361,22.6,44.702    c-0.026,0.542-0.459,0.974-1.002,0.971l-3.002-0.017c-0.562-0.003-1.024-0.47-1.001-1.031    c0.438-10.317,6.704-19.603,16.106-23.872C34.213,20.521,34.819,20.775,35.032,21.295z"></path><path d="M31.235,12.04l1.138,2.775c0.206,0.503-0.033,1.07-0.53,1.291c-11.298,5.033-18.816,16.176-19.253,28.537    c-0.019,0.544-0.455,0.977-0.999,0.974l-2.999-0.017c-0.561-0.003-1.02-0.468-1.002-1.028    c0.465-14.341,9.193-27.277,22.316-33.078C30.42,11.269,31.023,11.521,31.235,12.04z"></path></g></g><path fill="#000000" d="M79.051,66.067l-5.341-5.484V50.418c0-10.136-5.996-18.845-14.984-22.366  c-0.902-4.058-4.472-7.097-8.726-7.097c-4.254,0-7.824,3.039-8.726,7.097c-8.988,3.521-14.984,12.23-14.984,22.366v10.165  l-5.341,5.484c-0.473,0.486-0.738,1.137-0.738,1.815v7.744c0,1.391,1.128,2.519,2.519,2.519h16.805  C39.548,83.71,44.432,88.588,50,88.588c5.568,0,10.452-4.878,10.465-10.444H77.27c1.391,0,2.519-1.128,2.519-2.519v-7.744  C79.789,67.204,79.524,66.553,79.051,66.067z M50,83.55c-2.977,0-5.413-2.806-5.426-5.405h10.853  C55.413,80.744,52.977,83.55,50,83.55z M74.751,73.106H25.249v-4.234l6.079-6.241c0-5.971,0-11.127,0-12.213  c0-9.183,6.079-16.729,14.764-18.566c0-0.937,0-1.606,0-1.788c0-2.171,1.737-4.071,3.908-4.071c2.171,0,3.908,1.9,3.908,4.071  c0,0.181,0,0.851,0,1.788c8.684,1.837,14.764,9.382,14.764,18.566c0,1.357,0,6.241,0,12.213l6.079,6.241V73.106z"></path></svg>
    </div>
      )
}

export default ModaliOSAudioEnabler
